// components/DeeplinkHandler.js
import { useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getEventIndexPage } from 'redux/ducks/Event';
import { getReviewIndexPage } from 'redux/ducks/Dashboard';

const DeeplinkHandler = ({ authenticated, currentEventsList }) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const hasDispatchedRef = useRef(false);

  const getEventId = () => {
    const params = new URLSearchParams(location.search);
    const eventIdFromParams = params.get('event');

    if (eventIdFromParams) return eventIdFromParams;

    const pathMatch = location.pathname.match(/\/v2\/upcoming-event\/(\d+)/);
    return pathMatch ? pathMatch[1] : null;
  };

  useEffect(() => {
    if (!authenticated || hasDispatchedRef.current) return;

    const params = new URLSearchParams(location.search);
    const eventId = getEventId();
    const jobId = params.get('job');

    if (eventId) {
      dispatch(getEventIndexPage(eventId));
      hasDispatchedRef.current = true;
      return;
    }
    if (jobId) {
      dispatch(getReviewIndexPage(jobId));
      hasDispatchedRef.current = true;
    }
  }, [authenticated, location.search, location.pathname, dispatch]);

  useEffect(() => {
    if (!authenticated) return;

    if (['/v2/upcoming-event', '/dashboard'].includes(location.pathname)) return;

    const params = new URLSearchParams(location.search);
    const eventId = getEventId();
    const jobId = params.get('job');

    if (
      (Number.isInteger(parseInt(jobId)) &&
        Number.isInteger(parseInt(eventId))) &&
      currentEventsList.includes(eventId) &&
      authenticated
    ) {
      history.push(`/v2/upcoming-event/${eventId}/locations/all?job=${jobId}`);
      return;
    }

    if (Number.isInteger(parseInt(jobId)) && !eventId && authenticated) {
      history.push(`/dashboard?widget=reviews&job=${jobId}`);
      return;
    }
  }, [authenticated, currentEventsList, location.search, location.pathname, history]);

  return null;
};

export default DeeplinkHandler;